import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { authMe } from '../api/endpoints.js';
import type { UserSession } from '../api/types.js';

export function useAuth() {
  const qc = useQueryClient();
  const query = useQuery<UserSession | null, Error>({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        return await authMe();
      } catch (err: unknown) {
        if (axios.isAxiosError(err) && err.response?.status === 401) return null;
        throw err;
      }
    },
    staleTime: 30_000,
    retry: 0,
  });

  return {
    user: query.data,
    isLoggedIn: !!query.data,
    isLoading: query.isLoading,
    refresh: () => qc.invalidateQueries({ queryKey: ['me'] }),
  };
}
